import { render, staticRenderFns } from "./PricingTableROI.vue?vue&type=template&id=3451507e&scoped=true"
import script from "./PricingTableROI.vue?vue&type=script&lang=js"
export * from "./PricingTableROI.vue?vue&type=script&lang=js"
import style0 from "./PricingTableROI.vue?vue&type=style&index=0&id=3451507e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451507e",
  null
  
)

export default component.exports